module.exports = __webpack_public_path__ + "static/media/Study 03.690c39ec.png";